import React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Chip,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { BASE_ACCESS, BASE_ACCESS_NOTE, ROLE_ACCESS, roleLabel } from './roles';

export default function RoleAccessInfo() {
  return (
    <Accordion
      variant="outlined"
      disableGutters
      sx={{ borderRadius: 2, mb: 2, '&:before': { display: 'none' } }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Stack direction="row" spacing={1} alignItems="center">
          <InfoOutlinedIcon color="primary" fontSize="small" />
          <Typography sx={{ fontWeight: 'bold' }}>
            O que cada perfil de acesso pode acessar
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Box
          sx={{
            mb: 2,
            p: 1.5,
            borderRadius: 1,
            bgcolor: 'action.hover',
          }}
        >
          <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 0.5 }}>
            Telas base (disponíveis para todos os perfis)
          </Typography>
          <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
            {BASE_ACCESS.map((screen) => (
              <Chip key={screen} label={screen} size="small" variant="outlined" />
            ))}
          </Stack>
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
            {BASE_ACCESS_NOTE}
          </Typography>
        </Box>

        <Stack divider={<Divider flexItem />} spacing={1.5}>
          {ROLE_ACCESS.map((role) => (
            <Box key={role.key}>
              <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.5 }}>
                <Chip
                  label={roleLabel(role.key)}
                  size="small"
                  color={role.fullAccess ? 'primary' : 'default'}
                />
                <Typography variant="body2" color="text.secondary">
                  {role.description}
                </Typography>
              </Stack>
              {role.extraAccess.length > 0 && (
                <List dense disablePadding sx={{ pl: 1 }}>
                  {role.extraAccess.map((screen) => (
                    <ListItem key={screen} disableGutters sx={{ py: 0 }}>
                      <ListItemIcon sx={{ minWidth: 28 }}>
                        <CheckCircleOutlineIcon fontSize="small" color="success" />
                      </ListItemIcon>
                      <ListItemText
                        primary={screen}
                        primaryTypographyProps={{ variant: 'body2' }}
                      />
                    </ListItem>
                  ))}
                </List>
              )}
            </Box>
          ))}
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}
